<template>
  <button
    class="button -secondary mt-2 mb-2"
    id="mikmak-button"
    :data-mm-ids="productId"
    :data-mm-wtbid="mikmakWidgetId"
    :data-mm-sticky="mikmakStickyButton"
    v-bind="additionalProp"
    :aria-label="labelText"
  >
    {{ labelText }}
  </button>
</template>

<script>
import { AnalyticsHandler } from '../../scripts/directives/analyticsHandler/AnalyticsHandler';

export default {
  name: 'MikMakButton',
  props: {
    mikmakWidgetId: {
      type: String,
      required: false,
    },
    mikmakStickyButton: {
      type: Boolean,
      required: false,
    },
    labelText: {
      type: String,
      default: 'BUY NOW',
    },
    productId: {
      type: String,
      required: false,
    },
    analyticsData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    additionalProp() {
      return this.mikmakStickyButton
        ? { 'data-mm-main-id': this.productId }
        : {};
    },
  },
  mounted() {
    if (!window.swnDataLayer) window.swnDataLayer = {};
    window.swnDataLayer[`${this.$options.name}_widget_callback`] =
      this.handleMikMakEvents;
  },
  methods: {
    handleMikMakEvents(event) {
      if (event.action === 'clk') this.triggerAnalytics(event, 'buy_now');
      if (event.action === 'buy') this.addToCart(event);
      if (event.action === 'close')
        this.triggerAnalytics(event, 'close_eretail_popup');
    },
    addToCart(event) {
      const dimensions = {};
      for (const [key, value] of Object.entries(this.analyticsData)) {
        dimensions[key] = value;
      }
      try {
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          event_name: 'add_to_cart',
          eventCategory: 'ecommerce',
          product_info: `${event.product.name}::${event.product.id}`,
          step: 'redirection',
          store_name: event.store.name,
          ecommerce: {
            currencyCode: event.product.currency,
            add: {
              products: [
                {
                  name: event.product.name,
                  id: event.product.id,
                  price: event.product.price,
                  brand: event.product.brand,
                  category: event.product.categoryName,
                  ...dimensions,
                },
              ],
            },
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
    triggerAnalytics(event, eventName) {
      try {
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          event_name: eventName,
          ecommerce: 'undefined',
          product_info: `${event.product.name}::${event.product.id}`,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
